import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import classNames from 'classnames';
import style from './SearchFields.module.scss';

export const SearchFields: React.FC = () => {
	const {
		changeSearchStringForCategories,
		changeSearchStringForSubcategories,
		changeSearchStringForDishes,
		searchStringForCategories,
		searchStringForSubcategories,
		searchStringForDishes,
		activeItemToDisplay,
	} = useContext<IDishAssignmentContext>(DishAssignmentContext);

	const customerSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'categories',
	});
	const restaurantSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'subCategories',
	});
	const firmwareSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'dishes',
	});

	return (
		<div className={style.container}>
			<div className={customerSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForCategories}
					searchString={searchStringForCategories}
				/>
			</div>
			<div className={restaurantSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForSubcategories}
					searchString={searchStringForSubcategories}
				/>
			</div>
			<div className={firmwareSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForDishes}
					searchString={searchStringForDishes}
				/>
			</div>
		</div>
	);
};
